import './Dashboard.scss'
import './Help.scss'
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import {Container} from "react-bootstrap";
import {useContext} from "react";
import AppContext from "../AppContext";
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {Trans} from "react-i18next/icu.macro";

export default function Help() {
    const { t, i18n } = useTranslation();
    const app = useContext(AppContext)
    return <div id="page-dashboard" className={"page " + (app.ui.isDrawerOpen ? 'menu-shown' : '')}>
        <Sidebar />
        <div className="page-inner">
            <Header />
            <Container>
                <div className="dashboard-widgets two-columns">
                    <div className="dashboard-widget widget-get-help">
                        <h3 className="widget-title">{t('help.title')}</h3>
                        <div className="widget-body">
                            <div className="mb-5 text-muted">
                                <small>
                                    {t('help.subtitle')}
                                </small>
                            </div>
                            <div>
                                <ul className="contact-list">
                                    <li>
                                        <div className="sub-title mb-2">
                                            <strong>{t('help.mailUs')}</strong>
                                            <span className="sub-time-left">contact@turbotheorie.nl</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="sub-title mb-2">
                                            <strong>{t('help.callUs')}</strong>
                                            <span className="sub-time-left">(085) 064 5060</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="sub-title mb-2">
                                            <strong>WhatsApp</strong>
                                            <span className="sub-time-left">(085) 064 5060</span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="dashboard-widget widget-faq">
                        <h3 className="widget-title">FAQ</h3>
                        <div className="widget-body">
                            <div>
                                <div className="mb-3 text-muted">
                                    <strong>{t('help.faq1.title')}</strong>
                                    <br />
                                    <small>{t('help.faq1.text')}</small>
                                </div>
                                <div className="mb-3 text-muted">
                                    <strong>{t('help.faq2.title')}</strong>
                                    <br />
                                    <small><Trans i18nKey="help.faq2.text" components={[ <Link to="/account#subscriptions" /> ]} /></small>
                                </div>
                                <div className="mb-3 text-muted">
                                    <strong>{t('help.faq3.title')}</strong>
                                    <br />
                                    <small>{t('help.faq3.text')}</small>
                                </div>
                                <div className="mb-3 text-muted">
                                    <strong>{t('help.faq4.title')}</strong>
                                    <br />
                                    <small>
                                        {t('help.faq4.text')}
                                        <br />
                                        <a href="https://www.turbotheorie.nl" target="_blank">www.turbotheorie.nl</a>
                                    </small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Container>
        </div>
    </div>
}